import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      data-product-shop
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title}海报`}
          title={`${movie.title} - 一本道影视大全`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2 px-2 py-1 rounded-md bg-accent-500 text-primary-950 text-xs font-bold flex items-center gap-1">
          <i className="ri-star-fill text-xs"></i>
          {movie.rating.toFixed(1)}
        </div>
        <div className="absolute top-2 right-2 px-2 py-1 rounded-md bg-primary-900/80 text-background-50 text-xs font-medium">
          {movie.type}
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-bold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {movie.year} · {movie.genres.join(" / ")}
        </p>
        <p className="mt-1 text-xs text-foreground-400 truncate">{movie.region}</p>
      </div>
    </Link>
  );
}